module.exports = __webpack_public_path__ + "img/twitter_logo.6815cb28.png";